import React, { useState, useEffect } from "react";
import s from "../../admin_styles/UserSearch.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export default function UserFullInfoModal({ userId, onClose }) {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUserInfo = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/admin/get_user_full_info", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId })
      });

      const result = await res.json();
      setUserData(result.user);
    } catch (err) {
      console.error("Ошибка загрузки данных пользователя:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserInfo();
    }
  }, [userId]);

  if (!userId) return null;

  return (
    <div className={s.modalOverlay}>
      <div className={s.modalContent}>
        <button className={s.modalClose} onClick={onClose}>
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>

        {loading ? (
          <p>Загрузка...</p>
        ) : userData ? (
          <>
            <h3>Информация о пользователе</h3>
            <p><strong>ID:</strong> {userData.id}</p>
            <p><strong>Логин:</strong> {userData.login}</p>
            <p><strong>Имя:</strong> {userData.name}</p>
            <p><strong>Комментарий:</strong> {userData.comment || "-"}</p>
            <p><strong>TG ник:</strong> {userData.tgnikname ? (
          <a href={`https://t.me/${userData.tgnikname}`} target="_blank" rel="noopener noreferrer">
            {userData.tgnikname}
          </a>
        ) : (
          "-"
        )}</p>
            <p><strong>TG имя:</strong> {userData.tg_name}</p>
            <p><strong>TG ID:</strong> {userData.tg_user_id}</p>
            <p><strong>Количество проектов:</strong> {userData.project_count}</p>
            <p><strong>Тариф:</strong> {userData.tariff_name || "-"}</p>
            <p><strong>Баланс:</strong> {userData.balance !== null ? `${userData.balance} ₽` : "-"}</p>
            <p><strong>Дней хватит:</strong> {userData.days_left !== null ? userData.days_left : "-"}</p>
            <p><strong>Расход в день:</strong> {userData.total_daily_price !== null ? `${userData.total_daily_price} ₽` : "-"}</p>
            <p><strong>Дата окончания баланса:</strong> {userData.balance_end_date || "-"}</p>
            <p><strong>Триал до:</strong> {userData.trial_until || "-"}</p>
            <p><strong>Дата регистрации:</strong> {userData.reg_date ? userData.reg_date.split("T")[0] : "-"}</p>
            <h4>Подключённые сервисы</h4>
            {userData.user_services.length === 0 ? (
              <p>Нет подключённых сервисов</p>
            ) : (
              <table className={s.table}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Название</th>
                    <th>Техническое имя</th>
                    <th>Активен</th>
                    <th>Одноразовый</th>
                  </tr>
                </thead>
                <tbody>
                  {userData.user_services.map((s, index) => (
                    <tr key={index}>
                      <td>{s.service_id}</td>
                      <td>{s.name}</td>
                      <td>{s.technical_name}</td>
                      <td>{s.active ? "Да" : "Нет"}</td>
                      <td>{s.is_one_time ? "Да" : "Нет"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            <h4>Платежи</h4>
            {userData.payments.length === 0 ? (
              <p>Нет платежей</p>
            ) : (
              <table className={s.table}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Сумма</th>
                    <th>Описание</th>
                    <th>Дата</th>
                  </tr>
                </thead>
                <tbody>
                  {userData.payments.map((p) => (
                    <tr key={p.id}>
                      <td>{p.id}</td>
                      <td>{p.amount}</td>
                      <td>{p.description}</td>
                      <td>
                          {p.created_at
                            ? (() => {
                                const [date, time] = p.created_at.split("T");
                                const [y, m, d] = date.split("-");
                                const shortTime = time.slice(0, 5);
                                return `${d}.${m}.${y} ${shortTime}`;
                              })()
                            : "-"}
                        </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        ) : (
          <p>Данные не найдены</p>
        )}
      </div>
    </div>
  );
}
